// extracted by mini-css-extract-plugin
export default {"wrapper":"GiftPreview_wrapper__q1JdN","card":"GiftPreview_card__DGTAa"};